"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module TransactionBuilder
 */
var helpers_1 = require("./helpers");
var utils_1 = require("./utils");
var transaction_1 = require("./model/transaction");
var proposal_1 = require("./model/proposal");
var validator_1 = require("./modules/validator");
var types_1 = require("./model/types");
var utils_2 = require("./model/utils");
var TransactionBuilderError;
(function (TransactionBuilderError) {
    TransactionBuilderError["invalid_parameters"] = "invalid_parameters";
    TransactionBuilderError["failed_to_sign_transaction"] = "failed_to_sign_transaction";
})(TransactionBuilderError = exports.TransactionBuilderError || (exports.TransactionBuilderError = {}));
/**
 * Class contains available transaction operation names constants
 */
var TransactionBuilder = /** @class */ (function () {
    function TransactionBuilder() {
        this._operations = [];
        this._transaction = new helpers_1.dcorejs_lib.TransactionBuilder();
    }
    Object.defineProperty(TransactionBuilder.prototype, "operations", {
        /**
         * List of operations added to transaction
         * @return {Operation[]}
         */
        get: function () {
            return this._operations;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransactionBuilder.prototype, "transaction", {
        /**
         * Get dcorejs-lib format transaction.
         *
         * @returns {any}   dcorejs-lib transaction object.
         */
        get: function () {
            return this._transaction;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Append new operation to transaction object.
     *
     * @param {Operation} operation     Operation to append to transaction.
     * @return {boolean}                Successful operation add value.
     */
    TransactionBuilder.prototype.addOperation = function (operation) {
        if (operation === undefined || operation.name === undefined || operation.operation === undefined
            || typeof operation.name !== 'string') {
            throw new TypeError(TransactionBuilderError.invalid_parameters);
        }
        try {
            this._transaction.add_type_operation(operation.name, operation.operation);
            this._operations.push(operation);
        }
        catch (exception) {
            throw new Error(exception);
        }
    };
    /**
     * Transform transaction into proposal type transaction.
     *
     * @param {IProposalCreateParameters} proposalParameters     Proposal transaction parameters.
     */
    TransactionBuilder.prototype.propose = function (proposalParameters) {
        if (!validator_1.Validator.validateObject(proposalParameters, proposal_1.ProposalCreateParameters)) {
            throw new TypeError(TransactionBuilderError.invalid_parameters);
        }
        this._transaction.propose(proposalParameters);
    };
    /**
     * Broadcast transaction to DCore blockchain.
     *
     * @param {string} privateKey       Private key to sign transaction in WIF(hex)(Wallet Import Format) format .
     * @param sign                      If value is 'true' transaction will be singed, in 'false' transaction will not be signed.
     *                                  Default 'true'
     * @return {Promise<void>}          Void.
     */
    TransactionBuilder.prototype.broadcast = function (privateKey, sign) {
        var _this = this;
        if (sign === void 0) { sign = true; }
        if (!validator_1.Validator.validateArguments([privateKey, sign], [types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError(TransactionBuilderError.invalid_parameters);
        }
        var secret = utils_1.Utils.privateKeyFromWif(privateKey);
        return new Promise(function (resolve, reject) {
            if (sign) {
                _this.signTransaction(secret);
            }
            _this._transaction.broadcast()
                .then(function () {
                resolve();
            })
                .catch(function (err) {
                var e = new Error('error_broadcasting');
                e.stack = err;
                reject(e);
            });
        });
    };
    /**
     * Set transaction fee required for transaction operation
     *
     * @return {Promise<void>}  Void.
     */
    TransactionBuilder.prototype.setTransactionFees = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transaction.set_required_fees()
                .then(function () {
                _this._operations[0].operation['fee'] = _this._transaction.operations[0][1].fee;
                resolve();
            })
                .catch(function () {
                reject();
            });
        });
    };
    /**
     * Sign transaction with given private/public key pair.
     *
     * @param {KeyPrivate} privateKey   Private key to sign transaction.
     */
    TransactionBuilder.prototype.signTransaction = function (privateKey) {
        if (privateKey === undefined || privateKey.stringKey === undefined || typeof privateKey.stringKey !== 'string'
            || privateKey.key === undefined) {
            throw new TypeError(TransactionBuilderError.invalid_parameters);
        }
        try {
            var publicKey = utils_2.KeyPrivate.fromWif(privateKey.stringKey).getPublicKey().key;
            this._transaction.add_signer(privateKey.key, publicKey);
        }
        catch (exception) {
            throw new Error(TransactionBuilderError.failed_to_sign_transaction);
        }
    };
    /**
     * Replace operation on operationIndex with newOperation
     *
     * @param {number} operationIndex               Index of operation to replace. Must be greater than 0 and smaller than
     *                                              length of operations.
     * @param {Operation} newOperation              Operation to be placed to index.
     * @returns {boolean}                           Returns true if replaced, false otherwise.
     */
    TransactionBuilder.prototype.replaceOperation = function (operationIndex, newOperation) {
        if (!validator_1.Validator.validateArguments([operationIndex], [types_1.Type.number]) || !validator_1.Validator.validateObject(newOperation, transaction_1.Operation)) {
            throw new TypeError(TransactionBuilderError.invalid_parameters);
        }
        if (operationIndex >= 0 && operationIndex < this._operations.length) {
            try {
                this._transaction.add_type_operation(newOperation.name, newOperation.operation);
                this._operations[operationIndex] = newOperation;
                return true;
            }
            catch (exception) {
                if (process.env.ENVIRONMENT === 'DEV') {
                    console.log("debug => " + exception);
                }
                return false;
            }
        }
        return false;
    };
    /**
     * Displays current transaction
     * @returns {any}   dcorejs-lib format transaction object.
     */
    TransactionBuilder.prototype.previewTransaction = function () {
        return this._transaction;
    };
    return TransactionBuilder;
}());
exports.TransactionBuilder = TransactionBuilder;
//# sourceMappingURL=transactionBuilder.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/transactionBuilder.js
// module id = 19
// module chunks = 0